import React from "react";
import useEdd from "../../../hooks/useEdd";

const EstimatedDeliveryDate = ({ order }) => {
  const edd = useEdd({ order });
  return (
    <div className="omg-estimated-delivered-date-bs__wrap">
      <div className="omg-estimated-delivered-date-bs py-2">
        <div className="omg-estimated-delivered-date-bs__heading">
          <div className="omg-section__title">Estimated delivery date</div>
        </div>
        <div className="omg-estimated-delivered-date-bs__core omg-pair omg-section__content omg-special-tracking-carrier-name">
          {edd && (
            <span style={{ fontWeight: "normal" }}>{edd.join(" - ")}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default EstimatedDeliveryDate;
